import { Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { baseURL } from "../../api";
import { Global_Data } from "../../globalData/GlobalData";
import { sprintf, vsprintf } from 'sprintf-js';
import { useDispatch } from "react-redux";
import { setVarValue } from "../../utils/store/action/varValueActions";
import ComponentLoadingBoundary from "../Loading/ComponentLoadingBoundary";
import usePendingRequests from "../Loading/usePendingRequests";
import {
  getPlaceholderKeys,
  replaceBracketPlaceholders
} from "../InputTableDefault/utilities/replaceBracketPlaceholder";


function VarValue({ data, textValue: propTextValue }) {
  const [VarValue, setVarValuec] = useState({});
  const { token, textValue: globalTextValue, modalEditData } = Global_Data();
  const { loading, trackRequest } = usePendingRequests();

  const dispatch = useDispatch();

  function getFirstValidValue(...values) {
  return values.find(
    value => value !== undefined && value !== null && value !== ""
  ) ?? "";
}

function resolveFieldValue(source, field) {
  const value = source?.[field];

  if (value && typeof value === "object") {
    return (
      value.value ??
      value.sValue ??
      value.sCode ??
      value.sBrand ??
      value.id ??
      value.code ??
      ""
    );
  }

  return value;
}

  function replacePlaceholders(uri, data) {
    const regex = /{([^}]+)}/g;
    const replacedUri = uri?.replace(regex, (match, key) => {
      const value = data?.[key];
      return value !== "" && value !== undefined && value !== null ? value : match;
    });
    return replacedUri;
  }

async function GetVarValueData(processedURL) {
  try {
    const response = await trackRequest(() =>
      axios.get(`${baseURL}${processedURL}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    );

    const record = response?.data?.data?.records?.[0] || {};

    setVarValuec(prev => ({ ...prev, ...record }));
    dispatch(setVarValue(record));
  } catch (error) {
    console.log(error);
  }
}

  const dependencyFields = useMemo(() => {
    return getPlaceholderKeys(data?.data?.sDataAware);
  }, [data?.data?.sDataAware]);

  const dependencies = useMemo(() => {
    return dependencyFields.map(field =>
      getFirstValidValue(
        resolveFieldValue(propTextValue, field),
        resolveFieldValue(globalTextValue, field),
        resolveFieldValue(modalEditData, field)
      )
    );
  }, [propTextValue, globalTextValue, modalEditData, dependencyFields]);

useEffect(() => {
  if (data?.data?.sAction !== "CASCADE") return;

const awareFields = getPlaceholderKeys(data?.data?.sDataAware);

const awareValues = awareFields.reduce((acc, field) => {
  acc[field] = getFirstValidValue(
    resolveFieldValue(propTextValue, field),
    resolveFieldValue(globalTextValue, field),
    resolveFieldValue(modalEditData, field)
  );

  return acc;
}, {});


const processedURL = replaceBracketPlaceholders(
  data?.data?.sDataSource,
  awareValues
);

// console.log("VarValue CASCADE", {
//   sDataAware: data?.data?.sDataAware,
//   awareFields,
//   awareValues,
//   rawValues: awareFields.reduce((acc, field) => {
//     acc[field] = {
//       prop: propTextValue?.[field],
//       global: globalTextValue?.[field],
//       modal: modalEditData?.[field],
//     };
//     return acc;
//   }, {}),
//   processedURL
// });

  if (!processedURL || processedURL.includes("{") || processedURL.includes("}")) {
    setVarValuec(prev => Object.keys(prev || {}).length > 0 ? {} : prev);
    return;
  }

  GetVarValueData(processedURL);

}, [
  data?.data?.sAction,
  data?.data?.sDataSource,
  ...dependencies
]);
 
 
  function replacePlaceholders2(template, values) {
    return template?.replace(/{(\w+)}/g, function(match, key) {
        return typeof values?.[key] !== 'undefined' ? values?.[key] : ' ';
    });
  }

  let dataAwere = data?.data?.sDataAware?.replace(/[{}]/g, '')
  const num = +VarValue?.[data?.data?.sDisplayFields?.replace(/[{}]/g, '')] || 0
  let fomatedValue = replacePlaceholders(data?.data?.sDisplayFields,VarValue);
  if(fomatedValue && (fomatedValue.includes("{") || fomatedValue.includes("}"))){
    fomatedValue = ",";
  }
  const formattedValue = vsprintf(data?.data?.sDisplayFormat, fomatedValue?.split(','));
  let char = fomatedValue;

  if (/[a-zA-Z0-9]/.test(char)) {
    if(data?.data?.sDisplayFormat?.includes("%s")){
      char = vsprintf(data?.data?.sDisplayFormat, char?.split(','));
    } else {
      const values = char?.split(',')?.map((item) => {
        const trimmedValue = item.trim();
        return Number(trimmedValue);
      });
      char = vsprintf(data?.data?.sDisplayFormat, values);
      char = char.replace(/(\d+(\.\d+)?)/g, (match) => {
        const number = parseFloat(match);
        return number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }); 
    }
  } else {
    char = '';
  }
  function addThousandSeparatorToNumber(numberString) {
  // Convert the extracted number to a string with two decimal places
  const formattedNumber = parseFloat(numberString)?.toFixed(2);

  // Split the number into integer and decimal parts
  const [integerPart, decimalPart] = formattedNumber?.split('.');

  // Add comma separators to the integer part
  const formattedIntegerPart = integerPart?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Return the formatted number with the decimal part
  return `${formattedIntegerPart}.${decimalPart}`;
}

  function formatAllNumbersInString(input) {
    // Use a regular expression to match all numbers in the string
    return input?.replace(/-?\d+(\.\d+)?/g, match => addThousandSeparatorToNumber(match));
  }
  // let sv = {variant:"h4"}
  // const formattedValue3 = vsprintf(data.data.sDisplayFormat, char.split(','));
  return (
  <ComponentLoadingBoundary
    loading={loading}
    label={`Loading ${data?.component?.sName}`}
    minHeight={28}
    size={20}
  >
  {/* {data.data.sDisplayFormat} */}
  {/* {JSON.stringify(data?.component?.sProps)} */}
  {/*
  {JSON.stringify(fomatedValue.split(','))} */}
  {/* // return <Typography sx={{ color: "text.secondary" }}>{JSON.stringify(VarValue)}</Typography>; */}
  <Typography {...data?.component?.sProps} id={data?.component?.sName}>
    {
     /[a-zA-Z0-9]/.test(formattedValue) && !formattedValue.includes("NaN") && <div dangerouslySetInnerHTML={{__html: char}}/> 
    } 
    {/* {fomatedValue} */}
    {/* {fomatedValue.split(',')} */}
    </Typography>
  </ComponentLoadingBoundary>
  )
}

export default VarValue;
